module.exports = __webpack_public_path__ + "0349fb951eac0e0e4afa360dfe3b6493.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-17.png
// module id = 2251
// module chunks = 0